module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"DIMENSIONS":"DIMENSIONS","SIZE":"SIZE","result_filename":"Name of result file","creation_date":"Creation date"},"fr":{"DIMENSIONS":"DIMENSIONS","SIZE":"TAILLE","result_filename":"Nom du fichier résultat","creation_date":"Date de création"}}')
  delete Component.options._Ctor
}
